/**
 * 150 P2 (Import-Kette): reine Helfer fuer die Pruefansicht, ohne React — testbar in apps/web/test.
 */
import type { ParsedMenu } from "../ui/types";

export const IMPORT_SPRACHEN = ["en", "it", "fr"] as const;
export type ImportSprache = (typeof IMPORT_SPRACHEN)[number];

/**
 * Uebernimmt die Uebersetzungs-VORSCHLAEGE aus der Server-Antwort von `enrich step=translate` in den
 * lokalen Pruefstand. Nur dort, wo Titel/Name lokal noch gleich sind — was der Betreiber inzwischen
 * umbenannt hat, bekommt keine veraltete Uebersetzung.
 */
export function uebernehmeUebersetzungen(lokal: ParsedMenu, server: ParsedMenu): ParsedMenu {
  const next = structuredClone(lokal);
  next.sections.forEach((sec, si) => {
    const sSec = server.sections[si];
    if (!sSec) return;
    if (sSec.title === sec.title && sSec.translations) sec.translations = { ...sec.translations, ...sSec.translations };
    sec.items.forEach((it, ii) => {
      const sIt = sSec.items[ii];
      if (sIt && sIt.name === it.name && sIt.translations) it.translations = { ...it.translations, ...sIt.translations };
    });
  });
  return next;
}

/** Schwelle wie serverseitig (PREISSPRUNG_SCHWELLE): nur > 30 % wird markiert, genau 30 % nicht. */
export function preissprungProzent(altCents: number, neuCents: number | null): number | null {
  if (neuCents == null || neuCents <= 0 || altCents <= 0) return null;
  const delta = (neuCents - altCents) / altCents;
  return Math.abs(delta) > 0.3 ? Math.round(delta * 100) : null;
}
